import { create } from 'zustand';

import type { RealtimeConnection } from '@/hooks/realtime/useRealtimeChannel';

type InboxRealtimeState = {
  connection: RealtimeConnection;
  setConnection: (connection: RealtimeConnection) => void;
};

/**
 * The state of the app-wide inbox socket. An open support thread reads it to
 * decide whether to poll: anything but `live` means hints may be missed.
 * In-memory only; the socket it describes does not outlive the process.
 */
export const useInboxRealtimeStore = create<InboxRealtimeState>((set) => ({
  connection: 'down',
  setConnection: (connection) =>
    set((state) => (state.connection === connection ? state : { connection })),
}));

export function selectIsInboxLive(state: InboxRealtimeState): boolean {
  return state.connection === 'live';
}
